import { render, staticRenderFns } from "./TimelineCarousel.vue?vue&type=template&id=70390565&scoped=true&"
import script from "./TimelineCarousel.vue?vue&type=script&lang=js&"
export * from "./TimelineCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TimelineCarousel.vue?vue&type=style&index=0&id=70390565&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70390565",
  null
  
)

export default component.exports